import styled from 'styled-components';

export default styled.div`
  display: none;
  &.show {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Adjust the alpha value for transparency */
    z-index: 999; /* Ensure it appears above other content */
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
